import type { Action } from 'redux';
import { takeLatest, put } from 'redux-saga/effects';
import MachineAPI from '~/api/machine-api';
import AssetMapAndDetailsConstants from '~/domain/asset-details-common/components/AssetMapAndDetails/constants';
import { updateAsset } from '~/ducks/asset-updates/actions';
import { setOutdated } from '~/domain/asset-details-common/store/mapDetails/actions';
import callRequestSaga from '~/sagas/utils/request-saga';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

interface GetAssetDetailsAction extends Action<AssetMapAndDetailsConstants.GET_ASSET_DETAILS> {
  payload: {
    assetId: AssetId;
    limited?: boolean;
  };
}

export function* getAssetDetails({ payload: { assetId, limited } }: GetAssetDetailsAction) {
  const response = yield* callRequestSaga(
    limited ? MachineAPI.getAssetListItemById : MachineAPI.getAssetListItemV2ById,
    {
      request: AssetMapAndDetailsConstants.GET_ASSET_DETAILS_REQUEST,
      success: AssetMapAndDetailsConstants.GET_ASSET_DETAILS_SUCCESS,
      failure: AssetMapAndDetailsConstants.GET_ASSET_DETAILS_FAILURE,
      payload: {
        assetId,
      },
    },
    assetId
  );

  if (response instanceof BaseException) {
    return;
  }

  yield put(setOutdated(false));
  yield put(updateAsset({ assetId: assetId, asset: response, forceUpdate: true }));
}

function* getAssetDetailsSaga() {
  yield takeLatest(AssetMapAndDetailsConstants.GET_ASSET_DETAILS, getAssetDetails);
}

export default [getAssetDetailsSaga];
